import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";

import Login from "./Login";

const mapStateToProps = (_state) => ({
  // authReducer: state.auth
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Login),
);
